<template>
  <div class="common-container">
    <el-dialog title="" :close-on-click-modal="false" :visible.sync="loginDialog" class="loginDialog" width="880px"
      :append-to-body="true">
      <div class="content">
        <div class="dialog-l dialog-common">
          <div class="title">
            <img src="../assets/image/index/logo.png" class="titleLogo" alt="" />
            <span class="name">福安福茶社会化服务平台</span>
          </div>
        </div>
        <div class="dialog-r dialog-common">
          <i class="el-icon-close fontColor" @click="closeDialog"></i>
          <div class="formBox">
            <p class="title title-bottom-dl">用户登录</p>
            <el-form label-width="80px" ref="form" :model="form">
              <el-form-item label="用户名: ">
                <el-input v-model.trim="form.userAccount" placeholder="请输入账号"></el-input>
              </el-form-item>
              <el-form-item label="密码: ">
                <el-input v-model.trim="form.password" type="password" show-password placeholder="请输入密码"></el-input>
              </el-form-item>
              <el-form-item label="验证码: " class="input_code">
                <el-input v-model.trim="form.captcha" placeholder="请输入验证码">
                  <template slot="append">
                    <img :src="form.codeImg" class="codeImg" @click="handleCodeImg" />
                  </template>
                </el-input>
              </el-form-item>
              <el-form-item class="last-item last-item-dl">
                <button class="btn" @click="goLogin">登 录</button>
              </el-form-item>
            </el-form>
            <div class="goWhereBox goWhereBox-dl">
              <span class="l-text" @click="forgetPassword()">忘记密码？</span>
              <span class="r-text" @click="changeLogin('注册')">没有账号去注册→</span>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="" :close-on-click-modal="false" :visible.sync="registerDialog" class="loginDialog" width="880px"
      :append-to-body="true">
      <div class="content">
        <div class="dialog-l dialog-common">
          <div class="title">
            <img src="../assets/image/index/logo.png" class="titleLogo" alt="" />
            <span class="name">福安福茶社会化服务平台</span>
          </div>
        </div>
        <div class="dialog-r dialog-common">
          <i class="el-icon-close fontColor" @click="closeDialog"></i>
          <div class="formBox formBox-zc">
            <p class="title title-bottom-zc">用户注册</p>
            <el-form ref="registerform" label-width="100px" :model="registerform" :rules="registerRules">
              <el-form-item label="手机号: " prop="telNum">
                <el-input v-model.trim="registerform.telNum" maxlength="11" placeholder="请输入手机号"></el-input>
              </el-form-item>
              <el-form-item label="密码: " prop="password">
                <el-input v-model.trim="registerform.password" type="password" show-password placeholder="请输入密码">
                </el-input>
              </el-form-item>
              <el-form-item label="确认密码: " prop="password1">
                <el-input v-model.trim="registerform.password1" type="password" show-password placeholder="请输入密码">
                </el-input>
              </el-form-item>
              <el-form-item label="验证码: " class="input_code telBtn_item" prop="captcha">
                <el-input v-model="registerform.captcha" placeholder="请输入验证码">
                  <template slot="append">
                    <!-- <button class="tel-btn">获取验证码</button> -->
                    <el-button class="tel-btn" type="primary" :disabled="clockShow ? true : false"
                      @click="getTransactionInformation">
                      {{ clockShow ? clock + "s后重试" : "获取验证码" }}
                    </el-button>
                  </template>
                </el-input>
              </el-form-item>
              <el-form-item label="账号类型: " prop="accountType">
                <el-select v-model="registerform.accountType" placeholder="请选择">
                  <el-option v-for="item in accountOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="last-item last-item-zc">
                <button class="btn" @click="userRegistration('registerform')">
                  注 册
                </button>
              </el-form-item>
            </el-form>
            <div class="goWhereBox goWhereBox-zc">
              <span class="l-text" @click="forgetPassword()">忘记密码？</span>
              <span class="r-text" @click="changeLogin('登录')">已有账号，立即登录→</span>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="" :close-on-click-modal="false" :visible.sync="forgetThePassword" class="loginDialog"
      width="880px" :append-to-body="true">
      <div class="content">
        <div class="dialog-l dialog-common">
          <div class="title">
            <img src="../assets/image/index/logo.png" class="titleLogo" alt="" />
            <span class="name">福安福茶社会化服务平台</span>
          </div>
        </div>
        <div class="dialog-r dialog-common">
          <i class="el-icon-close fontColor" @click="closeDialog"></i>
          <div class="formBox formBox-zc">
            <p class="title title-bottom-zc">忘记密码</p>
            <el-form ref="forgetPasswordform" label-width="100px" :model="forgetPasswordform"
              :rules="forgetPasswordRules">
              <el-form-item label="手机号: " prop="mobile">
                <el-input v-model.trim="forgetPasswordform.mobile" maxlength="11" placeholder="请输入手机号"></el-input>
              </el-form-item>
              <el-form-item label="验证码: " class="input_code telBtn_item" prop="verifyCode">
                <el-input v-model="forgetPasswordform.verifyCode" placeholder="请输入验证码">
                  <template slot="append">
                    <!-- <button class="tel-btn">获取验证码</button> -->
                    <el-button class="tel-btn" type="primary" :disabled="clockShow ? true : false"
                      @click="forgetPasswordVerifCode">
                      {{ clockShow ? clock + "s后重试" : "获取验证码" }}
                    </el-button>
                  </template>
                </el-input>
              </el-form-item>
              <el-form-item label="密码: " prop="password">
                <el-input v-model.trim="forgetPasswordform.password" type="password" show-password placeholder="请输入密码">
                </el-input>
              </el-form-item>
              <el-form-item label="确认密码: " prop="password1">
                <el-input v-model.trim="forgetPasswordform.password1" type="password" show-password placeholder="请输入密码">
                </el-input>
              </el-form-item>
              <el-form-item class="last-item last-item-zc">
                <button class="btn" @click="retrievePassword('forgetPasswordform')">
                  确 定
                </button>
              </el-form-item>
            </el-form>
            <div class="goWhereBox goWhereBox-zc">
              <span class="r-text" @click="changeLogin('登录')">已有账号，立即登录→</span>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import eventBus from "../utils/js/eventBus.js";
import {
  getTransactionInformation, //手机验证码
  userRegistration, //注册
  getCaptcha,
  loginIn,
  retrievePassword,
  forgetPasswordVerifCode
} from "../utils/api/login";
export default {
  name: "register-login",
  data() {
    return {
      loginDialog: false,
      registerDialog: false,
      forgetThePassword: false,
      tagTitle: "登录",
      form: {
        // userAccount: "admin", // 账户
        // password: "abcdef_123456", // 账户
        userAccount: "", // 账户
        password: "", // 账户
        codeImg: "",
        captcha: "",
        timestamp: "",
      },
      accountOptions: [
        {
          value: "507",
          label: "普通用户",
        },
        {
          value: "508",
          label: "茶农",
        },
        {
          value: "509",
          label: "茶企",
        },
      ],
      accountType: "01",
      registerform: {
        // userAccount: "admin", // 账户
        // password: "abcdef_123456", // 账户
        telNum: "", // 手机号
        password: "", // 密码
        password1: "", // 确认密码
        captcha: "",
        accountType: "507",
        // timestamp: "",
      },
      forgetPasswordform: {
        userAccount: "", // 账户
        mobile: "", // 手机号
        password: "", // 密码
        password1: "", // 确认密码
        verifyCode: "" //验证码
      },
      forgetPasswordRules: {
        mobile: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern:
              "^(13[0-9]|14[5-9]|15[0-3,5-9]|16[2,5,6,7]|17[0-8]|18[0-9]|19[0-3,5-9])\\d{8}$",
            message: "请输入正确的手机号",
          },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        password1: [{ required: true, message: "请输入密码", trigger: "blur" }],
        verifyCode: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
      clockShow: false,
      clock: 180,
      loginRules: {},
      registerRules: {
        telNum: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern:
              "^(13[0-9]|14[5-9]|15[0-3,5-9]|16[2,5,6,7]|17[0-8]|18[0-9]|19[0-3,5-9])\\d{8}$",
            message: "请输入正确的手机号",
          },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        password1: [{ required: true, message: "请输入密码", trigger: "blur" }],
        captcha: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        accountType: [
          { required: true, message: "请选择类型", trigger: "change" },
        ],
      },
    };
  },
  created() { },
  mounted() {
    eventBus.$on("loginClick", (msg,msg1) => {
      if(msg1 == '登录'){
        this.loginDialog = msg;
        this.getLoginCaptcha();
      }else if(msg1 == '注册'){
        this.registerDialog = msg;
      }

    });
    // document.body.style.overflow = 'hidden';

  },
  methods: {
    //找回密码
    retrievePassword(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          if (this.forgetPasswordform.password != this.forgetPasswordform.password1) {
            return this.$message({
              type: "warning",
              message: "请确认两次密码是否一致！",
            });
          }
          let params = {
            userAccount: this.forgetPasswordform.mobile,
            mobile: this.forgetPasswordform.mobile,
            passWord: this.forgetPasswordform.password,
            verifyCode: this.forgetPasswordform.verifyCode,
          }
          console.log(params);
          let res = await retrievePassword(params)
          if (res.data.code == 200 || res.data.code == 0) {
            this.forgetThePassword = false;
            // this.$message({
            //   type: "success",
            //   message: "找回密码成功!",
            // });
            this.$confirm('密码找回成功，是否立即登录？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'success'
            }).then(() => {
              this.changeLogin("登录")
            }).catch(() => {
              this.forgetThePassword = false;
            });
          } else {
            this.$message({
              type: "warning",
              message: res.data.msg,
            });
          }
        } else {
          return false;
        }
      });
    },
    //忘记密码短信验证码
    async forgetPasswordVerifCode() {
      this.forgetPasswordform.userAccount = this.forgetPasswordform.mobile
      let params = {
        mobile: this.forgetPasswordform.mobile,
        userAccount: this.forgetPasswordform.userAccount,
      }
      let res = await forgetPasswordVerifCode(params)
      if (res.data.code == 0) {
        this.clockShow = true;
        this.$message({
          type: "success",
          message: res.data.msg,
        });
        this.setTime(); // 开始倒计时
      } else {
        this.$message({
          type: "error",
          message: res.data.msg,
        });
      }

    },
    //忘记密码
    forgetPassword() {
      this.loginDialog = false;
      this.registerDialog = false;
      this.forgetThePassword = true;
    },
    changeLogin(val) {
      this.tagTitle = val;
      if (this.tagTitle == "登录") {
        this.loginDialog = true;
        this.registerDialog = false;
        this.forgetThePassword = false;

      } else {
        this.loginDialog = false;
        this.forgetThePassword = false;
        this.registerDialog = true;
      }
    },
    closeDialog() {
      this.loginDialog = false;
      this.registerDialog = false;
      this.forgetThePassword = false;
      //   document.body.style.overflow = 'auto';
      //   eventBus.$emit("closeLoginDialog", this.myloginDialog);
    },
    // 获取短信验证码
    async getTransactionInformation() {
      this.clockShow = true;
      let params = {
        phone: this.registerform.telNum,
      };
      let res = await getTransactionInformation(params);

      if (res.data.code == 0) {
        this.$message({
          type: "success",
          message: res.data.msg,
        });
      } else {
        this.$message({
          type: "error",
          message: res.data.msg,
        });
      }
      this.setTime(); // 开始倒计时
    },
    // 倒计时函数封装
    setTime() {
      if (this.clock === 0) {
        this.clock = 180;
        this.clockShow = false;
        return;
      } else {
        this.clock--;
      }
      setTimeout(() => {
        this.setTime();
      }, 1000);
    },
    //注册
    userRegistration(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          // registerRules.telNum password password1 captcha accountType
          if (this.registerform.password != this.registerform.password1) {
            console.log(this.registerform.password);
            console.log(this.registerform.password1);
            return this.$message({
              type: "warning",
              message: "请确认两次密码是否一致！",
            });
          }
          let data = {
            phoneNo: this.registerform.telNum,
            userAccount: this.registerform.telNum,
            userPassword: this.registerform.password,
            verificationCode: this.registerform.captcha,
            roleIds: this.registerform.accountType,
          };
          let res = await userRegistration(data);
          if (res.data.code == 200 || res.data.code == 0) {
            this.$message({
              type: "success",
              message: "注册成功!",
            });
          } else {
            this.$message({
              type: "warning",
              message: res.data.msg,
            });
          }
          this.clock = 180;
          this.clockShow = false;
          this.registerform = {
            telNum: "",
            password: "",
            password1: "",
            captcha: "",
            accountType: "507",
          };
        } else {
          return false;
        }
      });
    },
    // 获取验证码
    async getLoginCaptcha() {
      this.form.timestamp = new Date().getTime();
      console.log(this.form.timestamp, "验证码时期");
      let params = {
        timestamp: this.form.timestamp,
      };
      let res = await getCaptcha(params);
      let data = res.data;
      this.form.codeImg =
        "data:image/png;base64," +
        btoa(
          new Uint8Array(data).reduce(
            (data, byte) => data + String.fromCharCode(byte),
            ""
          )
        );
    },
    // 点击切换验证码
    handleCodeImg() {
      this.getLoginCaptcha();
    },
    // 登录
    async goLogin(e) {
      if (e.preventDefault) {
        e.preventDefault();
      } else {
        window.event.returnValue == false;
      }
      if (this.form.captcha == "") {
        return this.$message({
          type: "warning",
          message: "请输入验证码！",
        });
      }
      if (this.form.userAccount == "") {
        return this.$message({
          type: "warning",
          message: "请输入账号！",
        });
      }
      if (this.form.password == "") {
        return this.$message({
          type: "warning",
          message: "请输入密码！",
        });
      }
      // console.log(this.form.timestamp, "登录");
      let data = {
        captcha: this.form.captcha,
        password: this.form.password,
        phone: this.form.userAccount,
        timestamp: this.form.timestamp,
      };

      // console.log(data);
      let res = await loginIn(data);
      if (res.data.code === 0) {
        console.log('登录res=========',res);
        localStorage.setItem("token", res.data.data.token);
        localStorage.setItem("userInfo", JSON.stringify(res.data.data.user));
        localStorage.setItem("isLogin", true);
        localStorage.setItem("isExpert", res.data.data.isExpert);
        this.$store.commit("UPDATE_TOKEN", res.data.data.token);
        this.$store.commit(
          "UPDATE_USERINFO",
          JSON.stringify(res.data.data.user)
        );
        // console.log('denglu232323',JSON.stringify(res.data.data.user))
        this.$store.commit("UPDATE_IsLogin", true);
        this.$store.commit("UPDATE_ISEXPERT", res.data.data.isExpert);
        // console.log(this.$store.state.isLogin,'this.$store.state.isLogin')
        this.loginDialog = false;
        // document.body.style.overflow = '';
        this.$router.push({ path: "index" });
        eventBus.$emit("hasLogin", true);
      } else if (res.data.code == -1) {
        this.$message({
          type: "warning",
          message: res.data.msg,
        });
        this.form.captcha = "";
        this.getLoginCaptcha();
      }
    },
  },
};
</script>

<style lang="scss">
// .common-container {
.loginDialog {
  .el-dialog {
    border-radius: 6px;
  }

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body.el-dialog__body {
    padding: 0 !important;
  }

  .content {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    // height: 530px;
    height: 530PX;
  }

  .dialog-common {
    width: 50%;
  }

  .dialog-l {
    width: 100%;
    height: 100%;
    background: url("../assets/image/login/loginBg.png") no-repeat;
    background-size: 100% 100%;

    .title {
      padding-left: 12px;
      padding-top: 12px;
      height: 40px;

      img {
        width: 34px;
        height: 37px;
        float: left;
      }

      .name {
        font-size: 22px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 40px;
        margin-left: 8px;
      }
    }
  }

  .dialog-r {
    width: 100%;
    height: calc(100% - 30px);
    position: relative;
    padding-top: 30px;

    .fontColor {
      font-size: 23px;
      color: #486c69;
      position: absolute;
      right: 12px;
      top: 8px;
      cursor: pointer;
    }

    .fontColor:hover {
      color: #4de6d9;
    }

    .formBox {
      // width: 100%;
      padding: 30px 20px 10px 20px;
      height: calc(100% - 40px);

      .title {
        text-align: center;
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #131616;
        line-height: 40px;
      }

      .title-bottom-dl {
        margin-bottom: 50px;
      }

      .title-bottom-zc {
        margin-bottom: 20px;
      }

      .el-form {
        width: 80%;
        margin: 0 auto;
      }

      .el-form-item {
        border: 1px solid #ccc;
        border-radius: 6px;
      }

      .last-item {
        border: none;

        .el-form-item__content {
          margin-left: 0 !important;
        }
      }

      .last-item-dl {
        margin-top: 80px;
      }

      .last-item-zc {
        margin-top: 20px;
      }

      .el-input__inner {
        border: none !important;
      }

      .codeImg {
        width: 120px;
        vertical-align: middle;
        height: 34px;
      }

      .el-input-group__append {
        padding: 0 8px 0 20px !important;
        border: none !important;
      }

      .btn {
        background: -webkit-linear-gradient(to right, #1cba4d, #a1dc61);
        background: -o-linear-gradient(right, #1cba4d, #a1dc61);
        background: -ms-linear-gradient(right, #1cba4d, #a1dc61);
        background: -moz-linear-gradient(right, #1cba4d, #a1dc61);
        background: linear-gradient(to right, #1cba4d, #a1dc61);
        border-radius: 6px;
        font-size: 18px;
        font-family: PingFangSC;
        color: #ffffff;
        line-height: 40px;
        width: 100%;
        border: none;
      }

      .tel-btn {
        background: -webkit-linear-gradient(to right, #1cba4d, #a1dc61);
        background: -o-linear-gradient(right, #1cba4d, #a1dc61);
        background: -ms-linear-gradient(right, #1cba4d, #a1dc61);
        background: -moz-linear-gradient(right, #1cba4d, #a1dc61);
        background: linear-gradient(to right, #1cba4d, #a1dc61);
        border-radius: 6px;
        font-size: 14px;
        font-family: PingFangSC;
        color: #ffffff;
        line-height: 30px;
        width: 80px;
        border: none;
      }
    }

    .goWhereBox {
      width: 80%;
      margin: 0 auto;

      .l-text {
        float: left;
        line-height: 30px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
        cursor: pointer;
      }

      .r-text {
        float: right;
        line-height: 30px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #d3602c;
        cursor: pointer;
      }
    }

    .goWhereBox-dl {
      margin-top: 30px;
    }

    //   .goWhereBox-zc {
    //     margin-top: 15px;
    //   }
    .formBox-zc {
      .el-form-item {
        margin-bottom: 20px;
      }
    }
  }

  .telBtn_item {
    .el-button {
      margin: 0 !important;
      padding: 3px 7px !important;
    }
  }

  .last-item-zc {
    margin-bottom: 12px !important;
  }
}

// }
</style>
